module.exports = __webpack_public_path__ + "img/colchoes.755947d4.webp";